import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "config-summary-row" }
const _hoisted_2 = { class: "config-summary-row__item-details" }
const _hoisted_3 = {
  key: 0,
  class: "config-summary-row__item-campaign"
}
const _hoisted_4 = {
  key: 1,
  class: "config-summary-row__item-spacer"
}
const _hoisted_5 = {
  key: 2,
  class: "config-summary-row__item-article-number"
}
const _hoisted_6 = { class: "config-summary-row__item-fee-name" }
const _hoisted_7 = { class: "config-summary-row__item-fee-price" }
const _hoisted_8 = { class: "config-summary-row__item-quantity" }
const _hoisted_9 = { class: "config-summary-row__item-price" }

import { computed } from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useContext from '@/composables/useContext';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfiguratorSummaryRow',
  props: {
  isDecoration: {
    type: Boolean,
    required: true
  },
  item: {
    type: Object,
    required: true
  },
  giftCardFreightPrice: {
    type: Number,
    default: 0
  },
  isGiftCard: {
    type: Boolean
  }
},
  setup(__props) {

const { formatPrice, isAuthorized, channel } = useContext();
const { websiteText } = useWebsiteTexts();

const props = __props;

const itemPrice = computed(() => {
  var price =
    props.item.price ?? props.item.currentPrice ?? props.item.originalPrice;
  if (
    channel.value.combineGiftCardPriceWithShipping &&
    props.isGiftCard &&
    !isAuthorized()
  ) {
    price += props.giftCardFreightPrice;
  }
  return price;
});

const pricePerItemText = computed(() => {
  return `(${formatPrice(itemPrice.value)}/${
    websiteText('productdetailspage_printpieceabbreviated').value
  })`;
});

const itemQuantityText = computed(() => {
  return `${props.item.quantity} ${
    websiteText('productdetailspage_printpieceabbreviated').value
  }`;
});

const totalRowPrice = computed(() => {
  return itemPrice.value * props.item.quantity;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'config-summary-row__item-name',
          { 'config-summary-row__item-decoration': __props.isDecoration }
        ])
      }, _toDisplayString(__props.item.name), 3),
      (__props.item.campaignPercentage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " (-" + _toDisplayString(__props.item.campaignPercentage) + "%) ", 1))
        : _createCommentVNode("", true),
      (!__props.isDecoration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      (!__props.isDecoration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.item.articleNumberForDisplay), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.isDecoration)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.item.addons, (addon) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "config-summary-row__item-fee",
            key: addon.name
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(addon.name), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatPrice)(addon.price)), 1)
          ]))
        }), 128))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        'config-summary-row__item-cost',
        { 'config-summary-row__item-product-indented': !__props.isDecoration }
      ])
    }, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(itemQuantityText.value) + " " + _toDisplayString(pricePerItemText.value), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(formatPrice)(totalRowPrice.value)), 1)
    ], 2)
  ]))
}
}

})